<template>
  <div>
    <header-applis index-progression-courante="3"/>
    <div class="wrapper__content app-element-center clearfix">
      <h2>Votre style d’apprentissage</h2>
      <div class="icon-information">
        <img :src="images.information" alt="">
      </div>
      <p>Afin de nous aider à personnaliser l’offre à votre profil, merci de répondre à ces dernières questions.</p>
      <router-link class="button-app button-primary start-button" tag="button" to="/activitesquotidiennes">OK, commençons les questions</router-link>
    </div>
    <footer-applis ecran-precedent="adapteraction"/>
  </div>
</template>

<script>
import FooterApplis from '../components/FooterApplis';
import HeaderApplis from '../components/HeaderApplis';

export default {
  name: 'questionsprofils',
  components: {
    HeaderApplis,
    FooterApplis,
  },
  data() {
    return {
      images: {
        information: require('../assets/images/information.svg'),
      }
    }
  },
}
</script>

<style scoped>
.app-element-center p {
  max-width: 35%;
  text-align: center;
}

.app-element-center .icon-information {
  align-items: center;
  display: flex;
  flex-direction: column;
  height: 8em;
  margin: 2rem auto;
  width: 8em;
}

.appcompetences_footer_suivant {
  float: right;
  margin: .5em;
  cursor: pointer;
  padding: .5rem .5rem;
  font-size: 1rem;
}
</style>